import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../lib/api';

const cities = ['Karachi', 'Lahore', 'Faisalabad', 'Islamabad', 'Multan', 'Other'];

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    company_name: '',
    owner_full_name: '',
    email: '',
    password: '',
    confirm_password: '',
    phone_number: '',
    city: '',
    ntn_number: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirm_password) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/register', {
        company_name: formData.company_name,
        owner_full_name: formData.owner_full_name,
        email: formData.email,
        password: formData.password,
        phone_number: formData.phone_number || null,
        city: formData.city || null,
        ntn_number: formData.ntn_number || null,
      });
      setSuccess(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      const message = Array.isArray(detail) ? detail[0]?.msg : detail;
      setError(message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-[#f0f2f5] flex items-center justify-center p-6" data-testid="registration-success-page">
        <div className="w-full max-w-md">
          <div className="bg-white border border-[#e5e7eb] rounded-2xl shadow-sm p-8 text-center">
            <img src="/logo.png" alt="SAMS" className="mx-auto h-24 w-auto object-contain mb-4" />
            <div className="mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#DBEAFE] mb-4">
                <svg className="w-8 h-8 text-[#4A7AE0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-[#1a1a2e] mb-2" data-testid="success-title">
                Account Created Successfully!
              </h2>
              <p className="text-sm text-[#6b7280] mb-4">
                Your SAMS account has been created. Our team will activate it within 24 hours.
              </p>
              <p className="text-sm text-[#52525B]">
                For faster activation WhatsApp us at <span className="font-semibold text-[#1E40AF]">03198561665</span>
              </p>
            </div>
            <Link
              to="/login"
              className="inline-block bg-[#1E40AF] text-white hover:bg-[#1e3a8a] rounded-xl px-6 py-2 font-semibold transition-colors"
              data-testid="go-to-login-button"
            >
              Go to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f0f2f5] flex items-center justify-center p-6" data-testid="register-page">
      <div className="w-full max-w-2xl">
        <div className="bg-white border border-[#e5e7eb] rounded-2xl shadow-sm p-8">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="SAMS" className="mx-auto h-24 w-auto object-contain mb-4" data-testid="register-logo" />
            <p className="text-sm text-[#6b7280]">Create Your Account</p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 p-3 bg-[#FEF2F2] border border-[#FCA5A5] rounded-xl text-[#EF4444] text-sm" data-testid="error-message">
                {error}
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="company_name">
                  Company Name *
                </label>
                <input
                  type="text"
                  id="company_name"
                  name="company_name"
                  data-testid="company-name-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.company_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="owner_full_name">
                  Owner Full Name *
                </label>
                <input
                  type="text"
                  id="owner_full_name"
                  name="owner_full_name"
                  data-testid="owner-name-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.owner_full_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="email">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  data-testid="email-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="phone_number">
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone_number"
                  name="phone_number"
                  data-testid="phone-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.phone_number}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="password">
                  Password *
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  data-testid="password-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="confirm_password">
                  Confirm Password *
                </label>
                <input
                  type="password"
                  id="confirm_password"
                  name="confirm_password"
                  data-testid="confirm-password-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="city">
                  City
                </label>
                <select
                  id="city"
                  name="city"
                  data-testid="city-select"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.city}
                  onChange={handleChange}
                >
                  <option value="">Select a city</option>
                  {cities.map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="ntn_number">
                  NTN Number <span className="text-[#52525B] text-xs">(optional)</span>
                </label>
                <input
                  type="text"
                  id="ntn_number"
                  name="ntn_number"
                  data-testid="ntn-input"
                  className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                  value={formData.ntn_number}
                  onChange={handleChange}
                />
              </div>
            </div>

            <button
              type="submit"
              data-testid="register-button"
              disabled={loading}
              className="w-full bg-[#1E40AF] text-white hover:bg-[#1e3a8a] rounded-xl px-4 py-2 font-semibold transition-colors disabled:opacity-50 mb-4"
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>

            <p className="text-center text-sm text-[#52525B]">
              Already have an account?{' '}
              <Link to="/login" className="text-[#1E40AF] hover:underline font-semibold" data-testid="login-link">
                Login here
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;